import { render } from "./GiftIcon.vue?vue&type=template&id=5883b786"
import script from "./GiftIcon.vue?vue&type=script&lang=js"
export * from "./GiftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__